import React from 'react';

interface HeaderProps {
  onUrlGen: () => void;
  onSave: () => void;
  onRender: () => void;
  onClose: () => void;
}

export function BlankHeader(props: {children: React.ReactNode, onHome: () => void}) {
  return (
    <div className="header flex">
      <div 
        className="headerTitle"
        onClick={props.onHome}
      >
        Fractal Explorer
      </div>
      <div className="headerButton">
        {props.children}
      </div>
    </div>
  );
}

export default function Header(props: HeaderProps) {
  return (
    <BlankHeader onHome={props.onClose}>
      <button onClick={props.onSave}>
        Save Fractal
      </button>
      <button onClick={props.onUrlGen}>
        Share as URL
      </button>
      <button onClick={props.onRender}>
        Render
      </button>
      <button onClick={props.onClose}>
        Menu
      </button>
    </BlankHeader>
  );
}